module.exports = __webpack_public_path__ + "assets/img/1201.6e900295.svg";